import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentResult() {
  const navigate = useNavigate();

  useEffect(() => {
    // Keepz redirects back here after payment
    // Redirect to pickup page with payment=success
    // The pickup code comes back in the address (works even if the bank app
    // returns to a different browser); this tab's saved code is the fallback.
    const fromUrl = (new URLSearchParams(window.location.search).get('code') || '').replace(/\D/g, '').slice(0, 8);
    if (fromUrl) { try { sessionStorage.setItem('pickup_code', fromUrl); } catch (e) { /* ignore */ } }
    const code = fromUrl || sessionStorage.getItem('pickup_code');
    if (code) {
      navigate(`/pickup?payment=success`);
    } else {
      navigate('/pickup');
    }
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', background: '#07080c', color: '#e4e5ed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p>იტვირთება... / Loading...</p>
    </div>
  );
}
